import { render, staticRenderFns } from "./ScrollBoard.vue?vue&type=template&id=853b4bbe&scoped=true&"
import script from "./ScrollBoard.vue?vue&type=script&lang=ts&"
export * from "./ScrollBoard.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollBoard.vue?vue&type=style&index=0&id=853b4bbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853b4bbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('853b4bbe')) {
      api.createRecord('853b4bbe', component.options)
    } else {
      api.reload('853b4bbe', component.options)
    }
    module.hot.accept("./ScrollBoard.vue?vue&type=template&id=853b4bbe&scoped=true&", function () {
      api.rerender('853b4bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-view/components/ScrollBoard.vue"
export default component.exports